import { useContext } from 'react';
import L10nContext from './l10n-context';

export default () => useContext(L10nContext);
